import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Spinner } from 'react-bootstrap';

interface IBlockingOverlay {
    show: boolean;
    message: string;
}

export function BlockingOverlay({ show, message }: IBlockingOverlay) {
    useEffect(() => {
        if (!show) return;

        const inertTargets = [
            document.getElementById('root'),
            ...Array.from(document.querySelectorAll<HTMLElement>('.modal')),
        ];
        inertTargets.forEach(target => target?.setAttribute('inert', ''));

        const warn = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', warn);

        return () => {
            inertTargets.forEach(target => target?.removeAttribute('inert'));
            window.removeEventListener('beforeunload', warn);
        };
    }, [show]);

    if (!show) return null;

    return createPortal(
        <div
            role="alert"
            aria-live="assertive"
            className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
            style={{ zIndex: 3000, backgroundColor: 'rgba(255, 255, 255, 0.85)', cursor: 'wait' }}
        >
            <Spinner animation="border" variant="primary" />
            <div className="fs-4 fw-bold mt-4 text-center px-4">{message}</div>
            <div className="text-muted mt-2">Please wait, do not close or leave this page.</div>
        </div>,
        document.body
    );
}
